import type { TFunction } from 'i18next'
import type { BuildInfo } from '@rollcall/contracts'

/**
 * Версия сборки и указание источника SRD.
 *
 * Версия — неброско, но на виду: когда пользователь присылает
 * «у меня не работает», первый вопрос — какая сборка.
 *
 * Указание источника — не оформление, а условие лицензии (D7,
 * `ATTRIBUTION.md`). Раньше оно висело неподвижной строкой поверх
 * листа и накрывало содержимое; теперь стоит на экране
 * «О приложении», ссылка на который есть в шапке каждого экрана.
 * CC BY 4.0 требует, чтобы указание было доступно, а не чтобы оно
 * лежало поверх текста. Формулировка приводится дословно —
 * переводить юридический текст нельзя.
 */

/**
 * Требуемый текст указания источника (SRD 5.2, CC BY 4.0).
 *
 * Вторая половина — отдельное условие лицензии (раздел 3.a.1.B):
 * назвать источник мало, нужно сказать, что материал изменён. Перевод
 * лицензия считает переработкой, и переведены все описания, а не
 * только заклинания, — формулировка это и говорит.
 */
export const SRD_NOTICE =
  'This work includes material from the System Reference Document 5.2 ' +
  '(“SRD 5.2”) by Wizards of the Coast LLC, available at ' +
  'https://www.dndbeyond.com/srd. The SRD 5.2 is licensed under the ' +
  'Creative Commons Attribution 4.0 International License, available at ' +
  'https://creativecommons.org/licenses/by/4.0/legalcode. ' +
  'Changes were made to the SRD 5.2: descriptions have been translated ' +
  'into Russian by the Rollcall project. This translation is not ' +
  'endorsed by Wizards of the Coast LLC.'

export const SRD_URL = 'https://www.dndbeyond.com/srd'
export const LICENCE_URL = 'https://creativecommons.org/licenses/by/4.0/legalcode'

export function versionLabel(t: TFunction, build: BuildInfo): string {
  return t('about.version', { version: build.version, commit: build.commit })
}
